import {kakaoRestAPI, constants} from '../data/httpWithAxios';
export default {
    param: {
        query: null,
        page: 1,
        size: 1
    },

    getCoordinate: function(address) {
        this.param.query = address;
        return kakaoRestAPI(constants.contentType.application_json, true)
            .get('/v2/local/search/address.json', {
                params: {
                    query: this.param.query,
                    page: this.param.page,
                    size: this.param.size
                }
            }).then(response => {
                return response;               
            });
    }
}


// WEBPACK FOOTER //
// ./src/api/kakao.js